// Phase 9 — global click delegation for tracked link types (mailto: and tel:).
//
// Why a single delegated listener instead of per-link onClick handlers:
//   - Footer, Header (top bar + mobile drawer), CTABand, Contact info card
//     and Careers band all surface mailto/tel anchors. Wiring each one would
//     duplicate analytics logic, and any new surface added later (blog post
//     bodies, sidebar widgets, embedded forms) would silently miss tracking.
//   - capture-phase listener runs BEFORE any preventDefault, so the event
//     fires even when the browser immediately hands off to the mail / dialer
//     app and the page is about to unload.
//
// All gtag / fbq calls are defensively guarded (`window.gtag && ...`), so
// while the site gate is locked (tracking scripts in index.html bail out
// before defining gtag/fbq), this module silently no-ops. Once unlocked +
// on a subsequent page load, the globals exist and click events flow.

export function initClickTracking() {
  if (typeof window === "undefined") return;
  if (window.__qvoltClickTrackingInit) return;
  window.__qvoltClickTrackingInit = true;

  document.addEventListener(
    "click",
    (event) => {
      // Walk up to the nearest <a> in case the click landed on an inner
      // span / icon / svg inside the anchor.
      const anchor = event.target?.closest?.("a[href]");
      if (!anchor) return;
      const href = anchor.getAttribute("href") || "";

      // ----- EMAIL LINKS — GA4 event + Google Ads conversion + Meta Contact
      if (href.startsWith("mailto:")) {
        try {
          window.gtag &&
            window.gtag("event", "email_link_click", {
              link_url: href,
              link_domain: "qvoltsolar.com.au",
            });
        } catch (_) {
          /* ignore */
        }
        try {
          window.gtag &&
            window.gtag("event", "conversion", {
              send_to: "AW-622264121/-CEOCNC7rKUDELn-26gC",
            });
        } catch (_) {
          /* ignore */
        }
        try {
          window.fbq &&
            window.fbq("track", "Contact", {
              content_name: "email_link_click",
            });
        } catch (_) {
          /* ignore */
        }
        return;
      }

      // ----- PHONE LINKS — GA4 event + Meta Contact (no Ads label yet)
      // The GA event name `clicked_to_call_from_mobile` is preserved from
      // the existing site for continuity. The event fires regardless of
      // device — GA4 + Ads can filter by device dimension at report time.
      if (href.startsWith("tel:")) {
        try {
          window.gtag &&
            window.gtag("event", "clicked_to_call_from_mobile", {
              link_url: href,
            });
        } catch (_) {
          /* ignore */
        }
        try {
          window.fbq &&
            window.fbq("track", "Contact", {
              content_name: "phone_link_click",
            });
        } catch (_) {
          /* ignore */
        }
        return;
      }
    },
    { capture: true }
  );
}
